var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-radio pa-2",class:{ checked: _vm.isChecked },on:{"click":_vm.toggleCheck}},[_c('div',{staticClass:"radio-circle"},[(_vm.isChecked)?_c('div',{staticClass:"check-mark"}):_vm._e()]),_c('span',{staticClass:"label pl-2"},[_vm._v(_vm._s(_vm._f("t")(_vm.label)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }